import TechnicalRU5 from "./5";
import TechnicalRU6 from "./6";
import TechnicalRU7 from "./7";

const pages = [
    {
        "id": "5",
        "title": "МАРКИРОВКА ШИН В ЕС",
        "image": "5f7d974f-d331-4ec7-94ee-e36dc62a416f.png",
        "description": "маркировка шины позволяет легче оценить протектора и аспекты безопасности и  аспекты окружающей среды.",
        "contentComponent": TechnicalRU5,
        "isPublished": true,
        "language": "ru",
        "createdAt": "2017-04-19T13:44:47",
        "updatedAt": "2017-04-19T14:16:58"
    },
    {
        "id": "6",
        "title": "МАРКИРОВКА АВТОМОБИЛЬНЫХ ШИН",
        "image": "abe206ff-468a-4c40-a244-613d4a12d506.png",
        "description": "Вы хотите выбрать и приобрести шины для автомобилей, но плохо то, что в условных обозначениях не удается ориентироваться?Это не проблема\r\n",
        "contentComponent": TechnicalRU6,
        "isPublished": true,
        "language": "ru",
        "createdAt": "2017-04-20T07:55:19",
        "updatedAt": "2017-04-20T14:28:16"
    },
    {
        "id": "7",
        "title": "Все о MOTO шинах ",
        "image": "b4961336-6ce7-4c88-abb0-adec05b54b5b.png",
        "description": "Для того, чтобы управлять мотоцикл не должен только опыт его управльные, но и шины, которые вы выбрали. Важным моментом является безопасность и безопасность начинается с выбора шин.",
        "contentComponent": TechnicalRU7,
        "isPublished": true,
        "language": "ru",
        "createdAt": "2017-05-11T13:06:28",
        "updatedAt": "2018-02-27T10:00:52"
    }
];

export default pages;
